export const loader = '<div class="sk-three-bounce">' +
                        '<div class="sk-child sk-bounce1"></div>' +
                        '<div class="sk-child sk-bounce2"></div>' +
                        '<div class="sk-child sk-bounce3"></div>' +
                    '</div>';

Handlebars.registerHelper('df-ui-loader', function () {

    return new Handlebars.SafeString(loader);
});

Handlebars.registerHelper('df-ui-loader-small', function () {

    return new Handlebars.SafeString(loader.replace('sk-three-bounce', 'sk-three-bounce sk-three-bounce--small'));
});



// WEBPACK FOOTER //
// ./shared/helper/loader.js